import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { trackVisit } from "@/lib/api";

import Home from "@/pages/Home";
import Poojas from "@/pages/Poojas";
import PoojaDetail from "@/pages/PoojaDetail";
import Guidance from "@/pages/Guidance";
import GuidanceDetail from "@/pages/GuidanceDetail";
import TempleHistory from "@/pages/TempleHistory";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import About from "@/pages/About";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import Enquiries from "@/admin/Enquiries";
import ContentManager from "@/admin/ContentManager";
import SettingsPage from "@/admin/SettingsPage";
import BlogBuilder from "@/admin/BlogBuilder";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const VisitTracker = () => {
  useEffect(() => {
    const isAdmin = window.location.pathname.startsWith("/admin");
    if (isAdmin) return;
    if (sessionStorage.getItem("sg_visit_tracked")) return;
    sessionStorage.setItem("sg_visit_tracked", "1");
    trackVisit();
    // Run once per session on mount; referenced values are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <VisitTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/poojas" element={<Poojas />} />
              <Route path="/poojas/:slug" element={<PoojaDetail />} />
              <Route path="/guidance" element={<Guidance />} />
              <Route path="/guidance/:slug" element={<GuidanceDetail />} />
              <Route path="/temple-history" element={<TempleHistory />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="enquiries" element={<Enquiries />} />
                <Route path="blog-builder" element={<BlogBuilder />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path=":collection" element={<ContentManager />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
